<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> All roles
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Display name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody v-for="role in roles">
                <tr @click="expandRole(role.id)">
                  <td>{{role.id}}</td>
                  <td>{{role.name}}</td>
                  <td>{{role.display_name}}</td>
                  <td>{{role.description}}</td>
                  <td><button type="button" class="btn btn-danger" v-on:click.stop="deleteRole(role.id)"><i class="fa fa-trash"></i></button></td>
                </tr>
                <tr v-show="expandedRoles[role.id]">
                  <td colspan="5">
                    <PermissionList :role="role"></PermissionList>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td><input type="text" placeholder="Name" class="form-control" v-model="newRoleName"></td>
                  <td><input type="text" placeholder="Display name" class="form-control" v-model="newRoleDisplayName"></td>
                  <td><input type="text" placeholder="Description" class="form-control" v-model="newRoleDescription"></td>
                  <td><button type="button" class="btn btn-primary" @click="saveRole(newRoleName, newRoleDisplayName, newRoleDescription)">Save</button></td>
                </tr>
              </tfoot>
            </table>
            <!--<nav>-->
              <!--<ul class="pagination">-->
                <!--<li class="page-item"><a class="page-link" href="#">Prev</a></li>-->
                <!--<li class="page-item active">-->
                  <!--<a class="page-link" href="#">1</a>-->
                <!--</li>-->
                <!--<li class="page-item"><a class="page-link" href="#">2</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">3</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">4</a></li>-->
                <!--<li class="page-item"><a class="page-link" href="#">Next</a></li>-->
              <!--</ul>-->
            <!--</nav>-->
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import PermissionList from './PermissionList';

export default {
  name: 'users',
  data: function () {
    return {
      expandedRoles: {},
      newRoleName: '',
      newRoleDisplayName: '',
      newRoleDescription: '',
      checkedPermissions: {}
    };
  },
  components: { PermissionList },
  computed: {
    ...mapGetters('Identities', [
      'roles',
    ])
  },
  methods: {
    ...mapActions('Identities', [
      'LOAD_ROLES', 'CREATE_ROLE', 'DELETE_ROLE'
    ]),
    expandRole(roleId) {
      if (!this.expandedRoles.hasOwnProperty(roleId)) {
        Vue.set(this.expandedRoles, roleId, true);
      } else {
        Vue.set(this.expandedRoles, roleId, !this.expandedRoles[roleId]);
      }
    },
    saveRole(name, display_name, description) {
      for (let i = 0; i < this.roles.length; i++) {
        if (this.roles[i].name == name) {
          window.alert('Duplicate role name!');
          return;
        }
      }
      this.CREATE_ROLE({ name: name, display_name: display_name, description: description });
    },
    deleteRole(id) {
      this.DELETE_ROLE(id);
    }
  },
  mounted() {
    this.LOAD_ROLES();
    // this.LOAD_PERMISSIONS();
  }
};
</script>
